import {_} from 'lodash';
import * as ko from 'knockout';
import {ObjectTypeId} from '../../../../constants';
import {IObjectData} from '../../../../index';
import {getRouteDefinition} from '../../../../constants/RouteDefinitions';
import {FilterType, IObjectSearchParams, template as tpl, viewModel as ObjectSearch} from '../../../object/search';
import {nsSearchToggle} from '../../../search/nsSearchToggle';
import ItemCheckbox = nsSearchToggle.ItemCheckbox;

export const template = tpl;

export interface IPickGroupsSearchParams extends IObjectSearchParams {
    excludedGroupIds: number[];
    selectedObjects: KnockoutObservableArray<IObjectData>;
}

/** Group search with checkboxes; groups already on the permission are visible but not selectable. */
export class viewModel extends ObjectSearch {
    private readonly excludedGroupIds: number[];

    constructor(params: IPickGroupsSearchParams) {
        super(_.defaultsDeep(params, {
            autoSelect: true,
            fnValidateRow: (obj: IObjectData) => !params.excludedGroupIds?.includes(obj.id),
            isSelectable: true,
            __routeDef: getRouteDefinition('groupsearch', {showHeading: false, level: 2}),
            __objectTypeId: ObjectTypeId.Group,
        }));
        this.excludedGroupIds = params.excludedGroupIds ?? [];
    }

    protected override onRowClick(item: IObjectData) {
        if (this.params.fnValidateRow && !this.params.fnValidateRow(item)) {
            return;
        }
        this.getItemCheckbox(item).toggle();
    }

    override isFilterAvailable(filterType: FilterType) {
        if (filterType === FilterType.Deleted) {
            return false;
        }
        return super.isFilterAvailable(filterType);
    }

    override showOperationsButton(): boolean {
        return false;
    }

    protected override showSelectedList = ko.pureComputed((): boolean => false);

    private isExcluded(obj: IObjectData): boolean {
        return this.excludedGroupIds.includes(obj.id);
    }

    protected override getRowBindings(obj: IObjectData): any {
        return this.isExcluded(obj)
            ? {class: 'rowDisabled'}
            : super.getRowBindings(obj);
    }

    protected override getItemCheckbox(item: IObjectData): ItemCheckbox<IObjectData> {
        const checkbox = super.getItemCheckbox(item);
        if (this.params.fnValidateRow && !this.params.fnValidateRow(item)) {
            checkbox.isEnabled = () => false;
        }
        return checkbox;
    }
}
